var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"img-company-logo__container"},[_c('img',{staticClass:"img-company-logo",attrs:{"src":_vm.src,"alt":"Company logo"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }